import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSmartwatch1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"smartwatch-1, clock, time"} maskId="square-filled-radius-0-stroke-1-IconSmartwatch1"><path fillRule="evenodd" clipRule="evenodd" d="M7.63997 1H16.3607L17.3607 4H20V20H17.3607L16.3607 23H7.63997L6.63997 20H4V4H6.63997L7.63997 1ZM7.69407 4H16.3066L15.64 2H8.36073L7.69407 4ZM7.69407 20L8.36073 22H15.64L16.3066 20H7.69407ZM12.5 8V11.7929L14.4571 13.75L13.75 14.4571L11.5 12.2071V8H12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSmartwatch1;
